import React from 'react';
import debounce from 'debounce'
import { withRouter } from 'react-router-dom';
import qs from 'qs';

import { 
    Form, 
    Input, 
    Button, 
    Select,
    Card, 
    message,
    InputNumber 
} from 'antd';

import {
    _getCartByOfflineReferenceNumber,
    _postSlaDiscrepency,
    _getSlaDiscrepency,
    _updateSlaDiscrepency
} from '../../services'

import {
    ADMIN_URL
} from '../../index'

import ProductSearch from './product-search';
import AdminSearch from './admin-search'

const { Option } = Select;
const { Item } = Form;

const reasons = [
    'Alternative Not Accepted',
    'Delivery Issue',
    'Long Lead Time',
    'No Response',
    'Payment Advice Not Received',
    'Payment Issue',
    'Price Issue',
    'Product Issue',
    'Product Spec Issue',
    'Quality Issue',
    'Stock Issue',
    'Unable To Advice Lead Time',
]

class SlaDiscrepanciesCreator extends React.Component {
    
    constructor(props){
        super(props)
        this.state = {
            products: [],
            offlineReferenceNumber: ''
        }
        // @KEN to add debounce
        // this.onOfflineReferenceChange = debounce(this.onOfflineReferenceChange, 400)

        if (this.props.slaId) {
            _getSlaDiscrepency({ slaId: this.props.slaId})
            .then(data => {
                this.setState({
                    ...data.data
                })
            })
        }
    }

    render() {

        const { getFieldDecorator } = this.props.form;
        const layout = {
            labelCol: {
                span: 7,
            },
            wrapperCol: {
                span: 17,
            },
        };

        const { 
            cartId,
            userEmail,
            enterpriseId,
            supplierId,
            mainCat,
            subCat,
            brand 
        } = this.state

        const disabled = Boolean(this.props.slaId)

        return (
            <Card style={{width: '80%'}} title={this.props.slaId ? 'SLA Discrepancy' : 'New SLA Discrepancy'}>
                <Form {...layout}>

                    <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr'}}>
                        <div>
                        <Item 
                            label="OfflineReferenceNumber">
                            {getFieldDecorator('offlineReferenceNumber', {
                                initialValue: this.state.offlineReferenceNumber,
                                placeholder: 'INV-2107-XXX',
                                rules: [
                                    { required: true, message: 'Please input the name offlineReferenceNumber'},
                                    { type: 'string', message: 'The input is not a valid offlineReferenceNumber'}
                                ],
                                value: this.state.offlineReferenceNumber,
                                onChange: (e)=>this.onOfflineReferenceChange(e)
                            })(
                                <Input disabled={disabled}/>
                            )}
                        </Item>    

                        {this.renderDisabledField({ label: 'Cart Id', fieldName: 'cartId', initialValue: cartId })}
                        {this.renderDisabledField({ label: 'User Email', fieldName: 'userEmail', initialValue: userEmail })}
                        {this.renderDisabledField({ label: 'Enterprise Id', fieldName: 'enterpriseId', initialValue: enterpriseId })}
                        </div>
                        <div>
                        <Item 
                            label="Product Title">
                            {getFieldDecorator('productTitle', {
                                initialValue: this.state.productTitle,
                                rules: [
                                    { required: true, message: 'Please input the Product Title'},
                                ],
                                onChange: (e)=>this.onProductChange(e)
                            })(
                                <Select disabled={disabled}>
                                    {this.state.products && this.state.products.map(_product => {
                                        return <Option value={_product.product._id}>{_product.product.title}</Option>
                                    }
                                    )}
                                </Select>
                            )} 
                        </Item>  

                        {this.renderDisabledField({ label: 'Supplier Id', fieldName: 'supplierId', initialValue: supplierId })}
                        {this.renderDisabledField({ label: 'Main Cat', fieldName: 'mainCat', initialValue: mainCat })}
                        {this.renderDisabledField({ label: 'Sub Cat', fieldName: 'subCat', initialValue: subCat })}
                        {this.renderDisabledField({ label: 'Brand', fieldName: 'brand', initialValue: brand })}
                        </div>
                    </div>

                    <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr'}}>
                        <div>
                            <Item
                                label="FD Ticket Num">
                                {getFieldDecorator('fdTicketNum', {
                                    initialValue: this.state.fdTicketNum,
                                })(
                                    <Input disabled={disabled}/>
                                )}
                            </Item>
                            <Item
                                label="Reason">
                                {getFieldDecorator('reason', {
                                    initialValue: this.state.reason,
                                    rules: [
                                        { required: true, message: 'Please input the Reason' },
                                    ],
                                })(
                                    <Select disabled={disabled}>
                                        {reasons.map(_reason => <Option value={_reason}>{_reason}</Option>)}
                                    </Select>
                                )}
                            </Item>
                            <Item
                                label="Responsibility">
                                {getFieldDecorator('responsibility', {
                                    initialValue: this.state.responsibility,
                                    rules: [
                                        { required: true, message: 'Please input the Responsibility' },
                                    ],
                                })(
                                    <Select disabled={disabled}>
                                        <Option value="buyer">Buyer</Option>
                                        <Option value="eezee">Eezee</Option>
                                        <Option value="supplier">Supplier</Option>
                                        <Option value="3pl">3PL</Option>
                                    </Select>
                                )}
                            </Item>
                        </div>
                        <div>
                            <Item 
                                label="Alternative Offered">
                                {getFieldDecorator('alternativeOfferedId', {
                                    initialValue: this.state.alternativeOfferedTitle,
                                })(
                                    <ProductSearch 
                                        onChange={this.onSearchChange}
                                        disabled={disabled}
                                        />
                                )} 
                            </Item>  
                            <Item
                                label="Remarks">
                                {getFieldDecorator('remarks', {
                                    initialValue: this.state.remarks,
                                })(
                                    <Input.TextArea
                                        disabled={disabled}
                                        rows={5}
                                    />
                                )}
                            </Item>
                        </div>
                       
                    </div>

                    {this.props.slaId && <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr'}}>
                        <h2>
                            Only PIC and Loss Amount can be edited!
                        </h2>
                        <div></div>
                        <Item
                            label="PIC">
                            {getFieldDecorator('pic', {
                                initialValue: this.state.pic,
                            })(
                                <AdminSearch 
                                    onChange={this.onPICChange}
                                    />
                            )}
                        </Item>
                        <Item
                            label="Loss Amount">
                            {getFieldDecorator('lossAmount', {
                                initialValue: this.state.lossAmount,
                                min: 0
                            })(
                                <InputNumber />
                            )}
                        </Item>
                    </div>}
                    
                    <div style={{display: 'flex'}}>
                        <Button 
                            style={{marginLeft: 'auto'}}
                            key="submit" 
                            type="primary" 
                            loading={false}
                            onClick={this.props.slaId ? this.handleEdit : this.handleSubmit}>
                        Submit
                        </Button>
                    </div>

                </Form>
                
            </Card>
        );
    }

    componentDidMount() {

        let location = this.props.location
        let search = location.search

        let params = qs.parse(search, { ignoreQueryPrefix: true })

        if (params.offlineReferenceNumber) {
            this.setState({ offlineReferenceNumber: params.offlineReferenceNumber })
            this.onOfflineReferenceChange({ target: { value: params.offlineReferenceNumber }})
        }

    }

    renderDisabledField = ({ label, fieldName, initialValue }) => {
        const { getFieldDecorator } = this.props.form;
        return (
            <Item label={label}>
                {getFieldDecorator(fieldName, {
                    initialValue: initialValue,
                    setFieldsValue: initialValue
                })(
                    <Input disabled={true}/>
                )}
            </Item>
        )
    }

    onOfflineReferenceChange = (e) => {

        const offlineReferenceNumber = e.target.value;
       
        message.loading('Getting Cart Info...')
        
        this.resetFields()

        _getCartByOfflineReferenceNumber(offlineReferenceNumber)
        .then(_data => {

            if (_data.data.success) {

                let _cart = _data.data._cart

                this.setState({
                    cartId: _cart._id,
                    checkOutDate: _cart.checkOutDate,
                    userId: `${_cart.user._id}`,
                    userEmail: _cart.user.local.email,
                    enterpriseId: _cart.enterpriseId,
                    offlineReferenceNumber: offlineReferenceNumber,

                    products: _cart.confirmCheckout.reduce((acc,cur) => {
                        return [...acc,...cur.products]
                    },[]),

                    _cart: _cart
                },() => {
                    message.destroy()
                    message.success('Cart found!',10)
                })
            }
            if (!_data.data.success) {
                message.error('Cart not found!',10)
            }
        })

    }

    resetFields = () => {

        let state = this.state
        let newState =  {}
        Object.keys(state).map( _key => {
            newState[_key] = null
        })

        this.setState(newState)
    }

    onProductChange = (e) => {

        let _product = this.state.products.filter(_product => e == `${_product.product._id}` )[0]

        this.setState({
            supplierId: _product.product.supplierId,
            productTitle: _product.product.title,
            productId: e,
            mainCat: _product.product.categories && _product.product.categories.mainKebabCase,
            subCat: _product.product.categories && _product.product.categories.subKebabCase,
            brand: _product.product.brand && _product.product.brand.kebabName,
        })

    }

    onSearchChange = (alternativeOfferedId, alternativeOfferedTitle) => {
        this.setState({
            alternativeOfferedId,
            alternativeOfferedTitle
        })
    }
    onPICChange = (pic) => {
        this.setState({
            pic,
        })
    }

    handleEdit = () => {
        this.props.form.validateFields((err, values) => {

            if (err) { 
                message.error('Please fill up all required fields!', 10)
                return 
            }

            let _data = this.props.form.getFieldsValue();
    
            let data = {
                lossAmount: _data.lossAmount,
                pic: _data.pic
            }

            _updateSlaDiscrepency({
                slaId: this.props.slaId,
                data,
            })
            .then(newSlaDiscrepency => {

                message.success('Record Updated!', 15)

            })
    
        })

    }

    handleSubmit = () => {
        this.props.form.validateFields((err, values) => {

            if (err) { 
                message.error('Please fill up all required fields!', 10)
                return 
            }

            let _data = this.props.form.getFieldsValue();
            const { _cart } = this.state
    
            let data = {
                cartId: _data.cartId,
                offlineReferenceNumber: _data.offlineReferenceNumber,
                checkOutDate: _cart.checkOutDate,
                userId: _data.userId,
                userEmail: _data.userEmail,
                enterpriseId: _data.enterpriseId,
                enterpriseCompanyName: '', 

                supplierId: _data.supplierId,
                productId: this.state.productId,
                productTitle: this.state.productTitle,
                mainCat: _data.mainCat,
                subCat:_data.subCat,
                brand: _data.brand,
                quantity: _data.quantity,

                fdTicketNum: _data.fdTicketNum,
                alternativeOfferedId: this.state.alternativeOfferedId,
                alternativeOfferedTitle: this.state.alternativeOfferedTitle,

            }

            _postSlaDiscrepency({
                data,
                reason: _data.reason,
                remarks: _data.remarks,
                responsibility: _data.responsibility
            })
            .then(newSlaDiscrepency => {

                this.resetFields()
                message.success('New Record Created!', 15)
                window.open(`${ADMIN_URL}/sla`)

            })
    
        })


        
    }

}

export default Form.create()(withRouter(SlaDiscrepanciesCreator))


// WEBPACK FOOTER //
// ./src/components/sla-discrepancies/creator.js